import { gql } from 'apollo-boost';

const getTwilioTokenGQL = gql`
  query twilioToken {
    getTwilioToken
  }
`;

export default getTwilioTokenGQL;
